// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4638":"css/app.6889","8007":"css/admin-app.6889"}[chunkId] + ".css";
};